import React from 'react';

export default function Card(props) {
    const {src,color,title,courseName} = props 

    //var device
    //var desc
    //var width
    var theme
    var texts

    if(color === 'dark'){
        theme = "card mb-3 mt-3 ml-auto mr-auto bg-edited card-hover"
        texts = "card-body text-light"

    } else if(color === 'light'){
        theme = "card mb-3 mt-3 ml-auto mr-auto bg-edited-light card-hover"
        texts = "card-body text-dark"
    }

    /*if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        //device = 'mobile'
        desc = "card-text d-none"
        width = '180px'
    } else {
        //device = 'pc'
        desc = "card-text"
        width = '520px'
    }*/

    return ( 
        <a className='card-hover' href={`/course/${courseName}`}>
        <div className={theme + ' cardTheme'}>
        <div className="row no-gutters">
            <div className="col-md-4">
            <img src={src} className="card-img" alt="..."/>
            </div>
            <div className="col-md-8">
            <div className={texts}>
                <h5 className="card-title text-center text-responsiveH5">{title}</h5>
                <p className='card-text cardText'>This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
            </div>
            </div>
        </div>
        </div>
        </a>
  );
}




